import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  template: `
    <div *ngIf="isVisible" class="rtl z-120 overflow-y-auto overflow-x-hidden flex fixed top-0 right-0 left-0 justify-center items-center w-full md:inset-0 h-full max-h-full">
        <div class="relative z-100 w-auto my-auto mx-auto max-w-4xl min-w-full">
        <div class="bg-white rounded-lg shadow relative p-4 w-full">
            <button (click)="close()" class="absolute top-3 right-3 text-gray-400 hover:text-gray-900 dark:hover:text-white">
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
                <span class="sr-only">Close modal</span>
            </button>
            <div class="md:p-5 text-center">
                <ng-content></ng-content>
            </div>
        </div>
    </div>

    <div *ngIf="isVisible" class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full top-0 right-0"></div>
    
  `
})
export class ModalComponent {
  isVisible = false;

  @Output() closed = new EventEmitter<void>();

  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.closed.emit();
  }
}


